import { render, staticRenderFns } from "./PrivacyUs.vue?vue&type=template&id=1bb4c93c&scoped=true&"
import script from "./PrivacyUs.vue?vue&type=script&lang=ts&"
export * from "./PrivacyUs.vue?vue&type=script&lang=ts&"
import style0 from "./PrivacyUs.vue?vue&type=style&index=0&id=1bb4c93c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb4c93c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCol,VContainer,VRow})
